{
    "actions": {
        "page": {
            "add_customization": "Create customization",
            "save": {
                "title": "Save",
                "success": "Customization saved successfully",
                "error": "Failed to save customization"
            },
            "publish": {
                "title": "Publish",
                "success": "Customization published successfully",
                "error": "Failed to publish customization"
            },
            "duplicate": "Duplicate",
            "tooltip": {
                "error": {
                    "title": "Attention check the following information :",
                    "input_error": "The required input fields must be filled",
                    "mode_automate_error": "In automate mode, only one and unique beneficiary is allowed"
                }
            }
        },
        "row": {
            "edit_label": "Update label",
            "duplicate": "Duplicate",
            "qr_code": "Show QR Code",
            "delete": "Delete"
        }
    },
    "keys": {
        "packageLabel": "Customization name",
        "packageCode": "Initialization code",
        "status": "Status",
        "posTerminalsNumbers": "Number of POS terminals",
        "updatedAt": "Last updated on",
        "color": "Color code",
        "logo": "Logo",
        "locale": "Language",
        "createdAt": "Creation date"
    },
    "filter": {
        "placeholder": {
            "package_code": "Filter by initialization code",
            "package_label": "Filter by label",
            "locale": "Filter by language",
            "color": "Filter by color code"
        }
    },
    "modal": {
        "update_label": {
            "title": "Update label",
            "label": "Customization name",
            "placeholder": "Enter customization name",
            "success": "Customization name updated successfully",
            "error": "Failed to update customization name"
        },
        "delete": {
            "title": "Delete customization",
            "update_date": "Last updated on",
            "status": "Status",
            "confirm": "Are you sure you want to delete the customization {{packageLabel}}?",
            "success": "Customization deleted successfully",
            "error": "Failed to delete customization"
        },
        "qr_code": {
            "title": "QR Code",
            "description": "This QR Code can be used to download your customization onto your TPE",
            "download": "Download here",
            "pdf": {
                "title": "Preludd Payment Services",
                "subtitle": "Discover Payludd: your hybrid payment solution on Stand-Alone TPE",
                "information": "Information",
                "merchant_account": "Merchant account:",
                "initialization_code": "Initialization code:",
                "customization_name": "Customization name:",
                "color_code": "Color code:",
                "selected_language": "Selected language:"
            }
        },
        "add_beneficiaries": {
            "title": "Beneficiary",
            "text": "Associate the beneficiaries of your merchant",
            "error": "An error occurred while retrieving the beneficiaries."
        }
    },
    "status": {
        "NEW": "New",
        "PUBLISHED": "Published",
        "DRAFT": "Draft"
    },
    "details": {
        "fields": {
            "init_code": {
                "label": "Initialisation code",
                "tooltip": "The initialization code is generated when the customization is published"
            },
            "name": {
                "label": "Customization name"
            },
            "locale": {
                "label": "Language choice"
            },
            "color": {
                "label": "Color code"
            },
            "logo": {
                "label": "Logo",
                "text1": "• 200 KB max",
                "text2": "• Format: jpeg, jpg, png",
                "error": "The selected file is too large"
            }
        },
        "functionnalities": {
            "payment_triggers": {
                "title": "Payment trigger mode",
                "keys": {
                    "port": "Port :",
                    "exchange_speed_hover": "Serial exchange speed (RS232)",
                    "exchange_speed": "Serial speed"
                },
                "options": {
                    "amountScreenDisplay": {
                        "title": "Manual amount entry"
                    },
                    "donationMode": {
                        "title": "Donations"
                    },
                    "automateMode": {
                        "title": "Automate",
                        "warning": "Only one beneficiary allowed for an automate"
                    },
                    "externalTrigger": {
                        "title": "Cash register",
                        "warning": "When a cash register mode is selected, we recommend securing the burger menu",
                        "error": "Please select at least one cash register mode",
                        "all_cashier_options": "all options",
                        "appToAppMode": "App2App",
                        "concertProtocolV320": "Wifi/Ethernet",
                        "concertProtocolV2Usb": "USB V2",
                        "concertProtocolV2": "RS232 V2",
                        "hover": {
                            "concertProtocolV320": "Wifi/ Ethernet (Concert V2 and V3.X)",
                            "concertProtocolV2Usb": "USB (Concert V2)",
                            "concertProtocolV2": "RS232 (Concert V2)"
                        }
                    }
                },
                "errors": {
                    "port_input": "Please enter a valid port number (1024-65535)"
                }
            },
            "lock": {
                "title": "Services and applications lock",
                "warning": "When an cashier mode is selected, we recommend securing the burger menu",
                "kioskMode": "[Coming soon] Application FRV6 locked (kiosk mode)",
                "burgerMenuLock": {
                    "text": "Password-protected menu",
                    "tooltip": "To access the menu a password is required. This is the 4 penultimate digits of the terminal's serial number. Please note: without the password it will be impossible to access the transaction history or reprint tickets."
                }
            },
            "payment_tickets": {
                "title": "Ticket payment management",
                "merchant": {
                    "title": "Merchant receipt",
                    "nativeMerchantReceipt": "Viewing and printing native merchant receipt"
                },
                "client": {
                    "title": "Customer receipt",
                    "option_1": "Viewing and printing native customer receipt",
                    "option_2": "Display customer receipt (QR Code)"
                }
            },
            "additional_services": {
                "title": "Additional services",
                "option_1": "TIP",
                "option_2": "Employee code entry",
                "option_3": "Order reference entry"
            }
        },
        "monetic_settings": {
            "gateway": {
                "title": "Gateways",
                "main_address": "Main address",
                "forcing_gateway": "Force the gateway",
                "tooltip": "All contracts present on the terminal will use this gateway",
                "address": "IP address: ",
                "port": "Port: ",
                "backup": "Backup",
                "none": "None"
            },
            "beneficiaries": {
                "title": "Beneficiary",
                "add": "Associate"
            }
        }
    }
}